var transperentElment = document.querySelector(".allow-transparent-header");
var header = document.querySelector(".header-wrapper");
if(transperentElment){
  header.classList.add("allow-transparent-header");
}


$(document).on('click', '.tab_animate_title', function(){
const $wrapper = $(this).closest('.tab_animate_title_wrp');
const index_new = $wrapper.find('.tab_animate_title').index(this);
$('.tab_animate_title_wrp').removeClass(function (i, className) {
  return (className.match(/\banimate_top-\S+/g) || []).join(' ');
});
$wrapper.addClass('animate_top-' + index_new);
['.tab_animate_title', '.tab_animate_text', '.tab_animate_image'].forEach(sel =>
  $(sel).attr('data-active', 'false'));
  $(this).attr('data-active', 'true');
  $('.tab_animate_text').eq(index_new).attr('data-active', 'true');
  $('.tab_animate_image').eq(index_new).attr('data-active', 'true');
});

gsap.registerPlugin(ScrollTrigger);
const section = document.querySelector(".tab_animate_img_text");
const titles = gsap.utils.toArray(".tab_animate_title");
titles.forEach((title, i) => {
  // if (i === 0) return;
  gsap.fromTo(
    title,
    { x: "-80%", opacity: 0 },
    {
      x: "0%",
      opacity: 1,
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: "top+=" + (i * 30) + " center+=150",
        end: "bottom bottom",
        scrub: false
        // markers: true
      },
    }
  );
});
// const texts = gsap.utils.toArray(".tab_animate_text");
// const images = gsap.utils.toArray(".tab_animate_image");


// if (document.body.clientWidth < 750) {
//   if (section && titles.length > 0) {
//     titles.forEach((el, i) => el.setAttribute("data-active", i === 0 ? "true" : "false"));
//     texts.forEach((el, i) => el.setAttribute("data-active", i === 0 ? "true" : "false"));
//     images.forEach((el, i) => el.setAttribute("data-active", i === 0 ? "true" : "false"));

//     const tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: section,
//         start: "top 100",
//         end: "+=" + (titles.length * 300) + "",
//         scrub: true,
//         // markers: true,
//         pin: true
//       },
//     });

//     titles.forEach((title, i) => {
//       // tl.call(() => activateTab(i), null, ">+=0.4");
//       tl.add(() => activateTab(i), i);
//     });

//     function activateTab(index) {
//       ['.tab_animate_title', '.tab_animate_text', '.tab_animate_image'].forEach(sel => {
//         document.querySelectorAll(sel).forEach(el => el.setAttribute('data-active', 'false'));
//       });
//       titles[index]?.setAttribute('data-active', 'true');
//       texts[index]?.setAttribute('data-active', 'true');
//       images[index]?.setAttribute('data-active', 'true');
//       const wrapper = document.querySelector('.tab_animate_title_wrp');
//       if (wrapper) {
//         wrapper.className = wrapper.className.replace(/\banimate_top-\S+/g, '');
//         wrapper.classList.add('animate_top-' + index);
//       }
//     }
//   }
// } else {
//   if (section && titles.length > 0) {
//     titles.forEach((el, i) => el.setAttribute("data-active", i === 0 ? "true" : "false"));
//     texts.forEach((el, i) => el.setAttribute("data-active", i === 0 ? "true" : "false"));
//     images.forEach((el, i) => el.setAttribute("data-active", i === 0 ? "true" : "false"));

//     const tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: section,
//         start: "top 100",
//         end: "+=" + (titles.length * 300) + "",
//         scrub: true,
//         // markers: true,
//         pin: true
//       },
//     });

//     titles.forEach((title, i) => {
//       // tl.call(() => activateTab(i), null, ">+=0.3");
//       tl.add(() => activateTab(i), i);
//     });

//     function activateTab(index) {
//       ['.tab_animate_title', '.tab_animate_text', '.tab_animate_image'].forEach(sel => {
//         document.querySelectorAll(sel).forEach(el => el.setAttribute('data-active', 'false'));
//       });
//       titles[index]?.setAttribute('data-active', 'true');
//       texts[index]?.setAttribute('data-active', 'true');
//       images[index]?.setAttribute('data-active', 'true');
//       const wrapper = document.querySelector('.tab_animate_title_wrp');
//       if (wrapper) {
//         wrapper.className = wrapper.className.replace(/\banimate_top-\S+/g, '');
//         wrapper.classList.add('animate_top-' + index);
//       }
//     }
//   }
// }




// $('.ct_ping-pop').on('click', function(){
//   $('#overlay').fadeIn();
//   var id = $(this).data('id');
//   $('.model_box[data-id="modal' + id + '"]').addClass('active');
//   });

//   $('.js-close-btn').on('click', function(){
//   $('#overlay').fadeOut();
//   $('.model_box').removeClass('active');
//   });
//   $('#overlay').on('click', function(){
//   $('#overlay').fadeOut();
//   $('.model_box').removeClass('active');
// });


$(document).ready(function () {

    // Open modal on hotspot click
  $('.ct_ping-pop').on('click', function(){
      $('#overlay').fadeIn();
      const id = $(this).data('id');
      showModal(id);
  });
  $('.js-close-btn, #overlay').on('click', function(){
      closeAll();
  });
  // Prev button logic and Next button logic
  $('.model_box_prev').on('click', function () {
      let current = getActiveModal();
      if(current > 1){
          showModal(current - 1);
      }
  });
  $('.model_box_next').on('click', function () {
      let current = getActiveModal();
      let last = $('.model_box').length;
      if(current < last){
          showModal(current + 1);
      }
  });
  function getActiveModal(){
      let active = $('.model_box.active').data('id'); 
      return Number(active.replace('modal', ''));
  }
  function showModal(id){
      $('.model_box').removeClass('active');
      $(`.model_box[data-id="modal${id}"]`).addClass('active');
      updateButtons(id);
  }
  function closeAll(){
      $('#overlay').fadeOut();
      $('.model_box').removeClass('active');
  }
  function updateButtons(id){
    let last = $('.model_box').length;

    // Prev disable on first
    if(id == 1){
        $('.model_box_prev').attr('disabled', true);
    } else {
        $('.model_box_prev').attr('disabled', false);
    }
    // Next disable on last
    if(id == last){
        $('.model_box_next').attr('disabled', true);
    } else {
        $('.model_box_next').attr('disabled', false);
    }
  }
});

$('.text-with_price .quantity__input').change(function(){
  let qty = $(this).val();
  let price_main = $(this).parents('.text-with_price').find('.price.price--large').attr('data-main-price');
  let price_compare = $(this).parents('.text-with_price').find('.compare-price.price').attr('data-compare-price');
  let total_price = price_main * qty / 100;
  let total_comprice = price_compare * qty / 100;
//   console.log(total_price);
  $(this).parents('.text-with_price').find('.price').text("Rs. "+ total_price);
  $(this).parents('.text-with_price').find('.compare-price.price').text("Rs. "+ total_comprice);
});

$('.img-video-pop_btn').click(function() {
  $(this).parents('.img-video-text-popup_section').addClass('img-video-pop_open');
})
$('.img-video-text-popup_close, .img-video-text-popup-overlay').click(function() {
  $(this).parents('.img-video-text-popup_section').removeClass('img-video-pop_open');
})



$(document).on('click', '.compare-models', function() {
  $('body').addClass('compare-models-pop_open');
})
$(document).on('click', '.compare_popup_close, .compare_popup_overlay', function() {
  $('body').removeClass('compare-models-pop_open');
})


$(document).ready(function () {

  // OPEN POPUP
  $(document).on('click', '[data-pop-btn]', function () {
    var popId = $(this).attr('data-pop-btn');

    $('.pdp-img-pop_overlay').addClass('active');
    $('.img-video-text-popup[data-pop-content="' + popId + '"]').addClass('active');
    $('body').addClass('popup-open');
  });

  // CLOSE POPUP (close icon OR overlay)
  $(document).on('click', '.img-video-text-popup_close, .pdp-img-pop_overlay', function () {
    $('.pdp-img-pop_overlay').removeClass('active');
    $('.img-video-text-popup').removeClass('active');
    $('body').removeClass('popup-open');
  });

  // ESC KEY CLOSE
  $(document).on('keyup', function (e) {
    if (e.key === "Escape") {
      $('.pdp-img-pop_overlay').removeClass('active');
      $('.img-video-text-popup').removeClass('active');
      $('body').removeClass('popup-open');
    }
  });

});





document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector(".step-animate_section");
  if (!section) return;

  const steps = gsap.utils.toArray(".step-animate-item");
  const baseLines = gsap.utils.toArray(".dummy_straight-line");

  gsap.set(
    [
      ...section.querySelectorAll(".step-animate-item_line"),
      ...section.querySelectorAll(".step-animate-item_content"),
      ...baseLines
    ],
    { opacity: 0 }
  );

  const tl = gsap.timeline({ paused: true });

  /* ✅ Delay before FIRST animation */
  tl.to({}, { duration: 0.5 });

  let baseIndex = 0;

  steps.forEach((step) => {
    const line = step.querySelector(".step-animate-item_line");
    const content = step.querySelector(".step-animate-item_content");

    /* STEP line + content together */
    tl.to([line, content], {
      opacity: 1,
      duration: 0.4,
      ease: "power2.out"
    });

    /* Baseline AFTER this step */
    const nextBaseLines = baseLines.slice(baseIndex, baseIndex + 11);
    baseIndex += 11;

    tl.to(nextBaseLines, {
      opacity: 1,
      duration: 0.5,
      ease: "power1.out",
      stagger: {
        each: 0.02,
        from: "start"
      }
    }, "-=0.3");
  });

  ScrollTrigger.create({
    trigger: section,
    start: "top 75%",

    onEnter: () => {
      tl.restart();
    },

    onEnterBack: () => {
      tl.restart();
    },

    onLeave: () => {
      tl.pause(0);
      gsap.set(
        [
          ...section.querySelectorAll(".step-animate-item_line"),
          ...section.querySelectorAll(".step-animate-item_content"),
          ...baseLines
        ],
        { opacity: 0 }
      );
    },

    onLeaveBack: () => {
      tl.pause(0);
      gsap.set(
        [
          ...section.querySelectorAll(".step-animate-item_line"),
          ...section.querySelectorAll(".step-animate-item_content"),
          ...baseLines
        ],
        { opacity: 0 }
      );
    }
  });

});


/**== Dawn Theme Color Thumbnail Show ==**/
// $(document).ready(function () {
//   let checkedVariant = $('.ct_color_box input[type="radio"]:checked').val();
//   console.log('checkedVariant:', checkedVariant);
//   $('.product__media-item').each(function () {
//       let firstvariant_img = $(this).data('color');
//       if (checkedVariant == firstvariant_img) {
//         $(this).addClass('var_color_true');
//       } else {
//         $(this).addClass('var_color_false');
//       }
//     });
//   $(document).on('change', '.ct_color_box input[type="radio"]', function () {
//     let selectedVariantId = $(this).val();
//     console.log("Variant changed:", selectedVariantId);
 
//     let $thumbnailItems = $(this).closest('.ct-product-slider').find('.product__media-item');
 
//     $thumbnailItems.each(function () {
//       let variant_img = $(this).data('color');
//       if (selectedVariantId == variant_img) {
//         console.log('true', variant_img);
//         // $('.thumbnail-list__item').removeClass('var_color_false');
//         $(this).removeClass('var_color_false');
//         $(this).addClass('var_color_true');
//       } else {
//         console.log('color not find', variant_img);
//         $(this).addClass('var_color_false');
//       }
//     });
//   });
// });

$(document).ready(function () {

  function updateGalleryByColor(selectedColor) {
    if (!selectedColor) return;

    $('.product__media-item').each(function () {
      let mediaColor = $(this).data('color');

      if (mediaColor == selectedColor) {
        $(this)
          .addClass('var_color_true')
          .removeClass('var_color_false');
      } else {
        $(this)
          .addClass('var_color_false')
          .removeClass('var_color_true');
      }
    });
  }

  /* -----------------------------
     INITIAL LOAD
  ------------------------------ */
  let initialColor = $('.ct_color_box input[type="radio"]:checked').val();
  updateGalleryByColor(initialColor);

  /* -----------------------------
     RADIO CHANGE (UI side)
  ------------------------------ */
  $(document).on('change', '.ct_color_box input[type="radio"]', function () {
    let selectedColor = $(this).val();
    updateGalleryByColor(selectedColor);
  });

  /* -----------------------------
     DAWN VARIANT CHANGE (REAL EVENT)
  ------------------------------ */
  document.addEventListener('variant:change', function (event) {
    if (!event.detail || !event.detail.variant) return;

    let variant = event.detail.variant;

    // change option index if needed (option2 / option3)
    let variantColor = variant.option1;

    updateGalleryByColor(variantColor);
  });

});

